import React from "react";
const Divider = ({ theme }) => {
  return (
    <>
     <hr  className="custom-divider"/>
    </>
  );
};

export default Divider;
